import React from 'react';
import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Box } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ReceiptIcon from '@mui/icons-material/Receipt';
import SavingsIcon from '@mui/icons-material/Savings';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSession } from '../../../core/context/SessionContext';

const TERMINAL_HISTORIAL_CODIGO = 10;

const drawerWidth = 240;

interface SidebarProps {
  open: boolean;
}

export const Sidebar: React.FC<SidebarProps> = ({ open }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { terminal } = useSession();

  const esDG = terminal?.codigo_terminal === TERMINAL_HISTORIAL_CODIGO;

  const menuItems = [
    ...(esDG ? [] : [{ text: 'Venta', icon: <ShoppingCartIcon />, path: '/venta' }]),
    { text: 'Historial', icon: <ReceiptIcon />, path: '/historial' },
    ...(esDG ? [{ text: 'Ventas Empaque', icon: <ReceiptIcon />, path: '/historial-detalle' }] : []),
    { text: 'Saldos', icon: <SavingsIcon />, path: '/saldos' },
    { text: 'Cotizador', icon: <RequestQuoteIcon />, path: '/cotizacion' },
  ];

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: open ? drawerWidth : 65,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: open ? drawerWidth : 65,
          boxSizing: 'border-box',
          overflowX: 'hidden',
          transition: 'width 0.2s',
          borderRight: '1px solid #e0e0e0'
        },
      }}
    >
      <Toolbar /> {/* Spacer for Header */}
      <Box sx={{ overflow: 'hidden' }}>
        <List>
          {menuItems.map((item) => (
            <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
              <ListItemButton
                onClick={() => navigate(item.path)}
                selected={location.pathname === item.path}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  '&.Mui-selected': {
                    backgroundColor: '#e3f2fd',
                    color: '#0066cc',
                    borderRight: '3px solid #0066cc'
                  },
                  '&.Mui-selected:hover': {
                    backgroundColor: '#e3f2fd',
                  }
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    color: location.pathname === item.path ? '#0066cc' : 'inherit'
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText 
                  primary={item.text} 
                  sx={{ opacity: open ? 1 : 0 }} 
                  slotProps={{ primary: { fontSize: '0.9rem', fontWeight: location.pathname === item.path ? 500 : 400 } }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};
